import React, { useState } from "react";
import PropTypes from "prop-types";
import componentStyles from "./AutoCompleteInput.module.scss"; // Optional: Add styles for the component

const AutoCompleteInput = ({ options, placeholder, value, onChange }) => {
  const [filteredOptions, setFilteredOptions] = useState(options);
  const [showOptions, setShowOptions] = useState(false);

  const handleInputChange = (e) => {
    const inputValue = e.target.value;
    onChange(inputValue);
    setFilteredOptions(
      options.filter((option) =>
        option.toLowerCase().includes(inputValue.toLowerCase())
      )
    );
    setShowOptions(true);
  };

  const handleOptionClick = (option) => {
    onChange(option);
    setShowOptions(false);
  };

  return (
    <div className={componentStyles.autoCompleteInput}>
      <input
        type="text"
        placeholder={placeholder}
        value={value}
        className={componentStyles.textInput}
        onChange={handleInputChange}
        onFocus={() => setShowOptions(true)}
        onBlur={() => setTimeout(() => setShowOptions(false), 200)} // Delay to allow option click
      />
      {showOptions && (
        <ul className={componentStyles.optionsList}>
          {filteredOptions.map((option, index) => (
            <li
              key={index}
              className="optionItem"
              onClick={() => handleOptionClick(option)}
            >
              {option}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

AutoCompleteInput.propTypes = {
  options: PropTypes.arrayOf(PropTypes.string).isRequired,
  placeholder: PropTypes.string,
  value: PropTypes.string,
  onChange: PropTypes.func.isRequired,
};

export default AutoCompleteInput;
